package com.xtream.ui.ui.widget

import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp


@Composable
fun InTvTextEdit(value: String?,
                 onValueChange: (String) -> Unit,
                 modifier: Modifier = Modifier,
                 enabled: Boolean = true,
                 textStyle: TextStyle = TextStyle.Default,
                 hint: String = "",
                 leadingIcon: ImageVector,
                 keyboardOptions: KeyboardOptions = KeyboardOptions.Default,
                 keyboardActions: KeyboardActions = KeyboardActions.Default,
){
    var focused by  remember { mutableStateOf(false) }

    BasicTextField(
        value = value.orEmpty(),
        onValueChange =onValueChange,
        modifier = modifier
            .border(
                width = 2.dp,
                color = if (focused) MaterialTheme.colorScheme.onBackground else Color.Transparent,
                shape = RoundedCornerShape(4.dp)
            )
            .padding(4.dp)
            .onFocusChanged {
                 focused = it.isFocused
            }, // Background with rounded corners
        keyboardActions = keyboardActions,
        keyboardOptions = keyboardOptions,
        textStyle = textStyle.copy( color = MaterialTheme.colorScheme.onBackground),
        cursorBrush = SolidColor(MaterialTheme.colorScheme.onSurface.copy(alpha = .5f)),
        singleLine = true,
        enabled = enabled,

        decorationBox = { innerTextField ->

            Box(
                contentAlignment = Alignment.CenterStart
            ){
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(
                        leadingIcon,
                        contentDescription = hint,
                        tint = Color.Gray
                    )
                    Spacer(modifier = Modifier.width(8.dp)) // Space between icon and text field
                    if (value.isNullOrEmpty() == true) {
                        Text(
                            text = hint,
                            overflow = TextOverflow.Ellipsis,
                            style = MaterialTheme.typography.bodyMedium,
                            color = MaterialTheme.colorScheme.onBackground.copy(alpha = .5f),
                            maxLines = 1
                        )
                    }
                    innerTextField()
                }


            }
        }
    )
}